export const ADD_FETCHING_MEDIA = 'ADD_FETCHING_MEDIA'
export const addFetchingMedia = (start, end) => ({
    type: ADD_FETCHING_MEDIA,
    start,
    end,
})

export const INIT_FETCHING_MEDIA = 'INIT_FETCHING_MEDIA'
export const initFetchingMedia = () => ({
    type: INIT_FETCHING_MEDIA,
})
